import bet from './modules/bet/store.js'
import soloGame from './modules/solo-game/store'
import player from './modules/player/store'
import game from './modules/game/store'
import report from './modules/report/store'
import feedback from './modules/feedback/store'

export default { bet, soloGame, player, game, report, feedback }